import { GameEventHandler, isGameEventHandler } from "../entity/Entity";
import IOEventHandler from "../entity/IoEvents";
import FilterSet from "../util/FilterSet";
/**
 * Manages collections of IO event handlers with optimized filtering.
 * Maintains separate filtered sets for different input event types
 * to enable efficient event dispatching without checking every handler.
 */
export default class IOHandlerList implements Iterable<IOEventHandler> {
  all = new Set<IOEventHandler>();

  filtered = {
    onButtonDown: new FilterSet(isGameEventHandler("buttonDown")),
    onButtonUp: new FilterSet(isGameEventHandler("buttonUp")),
    onClick: new FilterSet(isGameEventHandler("click")),
    onKeyDown: new FilterSet(isGameEventHandler("keyDown")),
    onKeyUp: new FilterSet(isGameEventHandler("keyUp")),
    onMouseDown: new FilterSet(isGameEventHandler("mouseDown")),
    onMouseUp: new FilterSet(isGameEventHandler("mouseUp")),
    onRightClick: new FilterSet(isGameEventHandler("rightClick")),
    onRightDown: new FilterSet(isGameEventHandler("rightDown")),
    onRightUp: new FilterSet(isGameEventHandler("rightUp")),
    onInputDeviceChange: new FilterSet(isGameEventHandler("inputDeviceChange")),
  };

  get onButtonDown(): Iterable<GameEventHandler<"buttonDown">> {
    return this.filtered.onButtonDown;
  }
  get onButtonUp(): Iterable<GameEventHandler<"buttonUp">> {
    return this.filtered.onButtonUp;
  }
  get onClick(): Iterable<GameEventHandler<"click">> {
    return this.filtered.onClick;
  }
  get onKeyDown(): Iterable<GameEventHandler<"keyDown">> {
    return this.filtered.onKeyDown;
  }
  get onKeyUp(): Iterable<GameEventHandler<"keyUp">> {
    return this.filtered.onKeyUp;
  }
  get onMouseDown(): Iterable<GameEventHandler<"mouseDown">> {
    return this.filtered.onMouseDown;
  }
  get onMouseUp(): Iterable<GameEventHandler<"mouseUp">> {
    return this.filtered.onMouseUp;
  }
  get onRightClick(): Iterable<GameEventHandler<"rightClick">> {
    return this.filtered.onRightClick;
  }
  get onRightDown(): Iterable<GameEventHandler<"rightDown">> {
    return this.filtered.onRightDown;
  }
  get onRightUp(): Iterable<GameEventHandler<"rightUp">> {
    return this.filtered.onRightUp;
  }
  get onInputDeviceChange(): Iterable<GameEventHandler<"inputDeviceChange">> {
    return this.filtered.onInputDeviceChange;
  }

  add(handler: IOEventHandler) {
    this.all.add(handler);
    for (const list of Object.values(this.filtered)) {
      list.addIfValid(handler);
    }
  }

  remove(handler: IOEventHandler) {
    this.all.delete(handler);
    for (const list of Object.values(this.filtered)) {
      list.remove(handler);
    }
  }

  [Symbol.iterator]() {
    return this.all[Symbol.iterator]();
  }
}
